<template>
  <div>
    <loading v-if="showLoadingPage" :message="message"></loading>
    <div v-else>
      <div id="page-container">
        <side-bar :organization="organization"></side-bar>
        <user-slide-out></user-slide-out>
        <section id="main-section">
            <nav-bar>
            <loader id="main-loader" :showLoader="showLoader" />
            </nav-bar>
            <div id="main-content">
            <transition name="fade" mode="out-in">
              <router-view />
            </transition>
            </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import utils from '@/mixins/utils';
import SideBar from '@/components/SideBar.vue';
import NavBar from '@/components/NavBar.vue';
import Loader from '@/components/Loader.vue';
import UserSlideOut from '@/components/UserSlideOut.vue';
import Loading from '@/views/Loading.vue';

export default {
  name: 'Page',
  mixins: [utils],
  components: {
    SideBar,
    NavBar,
    Loader,
    UserSlideOut,
    Loading,
  },
  computed: {
    ...mapState(['globalErrorMessage']),
    ...mapState('primary', ['organization']),
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters(['showLoader']),
    showLoadingPage() {
      return this.loading;
      // return this.isLoggedIn === false || this.organization === null;
    },
  },
  data() {
    return {
      message: 'Initializing User',
      loading: true,
    };
  },
  async mounted() {
    this.initializeSite();
  },
  watch: {
    async isLoggedIn() {
      this.initializeSite();
    },
  },
  methods: {
    async initializeSite() {
      if (this.isLoggedIn) {
        this.message = 'Getting organization information';
        await this.$store.dispatch('initializeData');
        if (this.organization === null) {
          this.message = 'Error getting organization information';
          return;
        }
        this.message = 'Loading scripts';
        await this.$store.dispatch('mk/loadMapKit');
        this.message = 'All good, taking you to your dashboard!';
        await this.sleep(1000);
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">

</style>
